<script>
import BaseWidgetForm from './BaseWidgetForm'
import fields from '@/components/fields/'
import { get } from 'lodash'

export default {
  extends: BaseWidgetForm,
  data() {
    return {
      arrayFields: ['items']
    }
  },
  computed: {
    tabsFieldsSchema() {
      return [
        {
          label: 'Ogólne',
          fields: [
            ...this.getCommonFields(),
            new fields.Input({
              label: 'Tytuł',
              modelPath: [this, 'form', 'title'],
              required: true,
              multilingual: true
            }),
            new fields.Input({
              label: 'Podtytuł',
              modelPath: [this, 'form', 'subtitle'],
              required: true,
              multilingual: true
            }),
            new fields.Header({
              type: 'h3',
              text: 'Elementy'
            }),
            new fields.Formset({
              modelPath: [this, 'form', 'items'],
              items: this.form.items.map((item, i) => {
                return {
                  headerLabel: get(item, ['text_pl']),
                  fields: [
                    new fields.Input({
                      label: 'Tekst',
                      modelPath: [this, 'form', 'items', i, 'text'],
                      multilingual: true
                    })
                  ]
                }
              })
            })
          ]
        }
      ]
    }
  }
}
</script>
